import { generatePath } from "@routes/generatePath";

const familyMemberViewRoute = "/my-family/view/:id";
const familyMemberEditRoute = "/my-family/edit/:id";
const familyMemberCreateRoute = "/my-family/create";

export const path = {
  familyMemberView: {
    route: familyMemberViewRoute,
    link: (id: string) => generatePath(familyMemberViewRoute, { id }),
  },
  familyMemberEdit: {
    route: familyMemberEditRoute,
    link: (id: string) => generatePath(familyMemberEditRoute, { id }),
  },
  familyMemberCreate: {
    route: familyMemberCreateRoute,
    link: () => generatePath(familyMemberCreateRoute),
  },
  myFamily: {
    route: "/my-family",
    link: () => path.myFamily.route,
  },
};
